import type { OwaDate } from "../schema";
import { utcDate } from "./owaDate";
import { MIN_JAVASCRIPT_TIMESTAMP, MAX_JAVASCRIPT_TIMESTAMP } from "owa-date-constants";

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function utcDate called at module scope is not allowed. This may cause unwanted side effects. */
export const MIN_JAVASCRIPT_DATE: OwaDate = utcDate(MIN_JAVASCRIPT_TIMESTAMP);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function utcDate called at module scope is not allowed. This may cause unwanted side effects. */
export const MAX_JAVASCRIPT_DATE: OwaDate = utcDate(MAX_JAVASCRIPT_TIMESTAMP);
